import React from 'react';
import { useDispatch } from 'react-redux';
import { appManager } from '../../state/app/manager';
import { useInstrumentVisibility, VisibilityEditor } from '.';

type Session = {
  id: number;
  status: number;
  which_markets: number;
  underlying_assets?: number[];
  markets_v5_hidden_assets?: number[];
  is_blueprint?: boolean;
};
export function useLegacyInstrumentVisibility(
  session: Session,
  readOnly = false,
) {
  const dispatch = useDispatch();
  return useInstrumentVisibility({
    sessionId: session.id,
    engine: 'legacy',
    enabled:
      !session.is_blueprint &&
      session.status !== 3 &&
      [0, 4].includes(session.which_markets),
    readOnly: readOnly || session.status === 2,
    hiddenAssetIds: session.markets_v5_hidden_assets,
    scopeKey: session.underlying_assets?.join(','),
    onSaved: ids =>
      dispatch(
        appManager.socketEvents.markets_v5_hidden_assets_updated({
          session_id: session.id,
          markets_v5_hidden_assets: ids,
        }),
      ),
  });
}
export function LegacyVisibilityEditor({
  session,
  readOnly,
}: {
  session: Session;
  readOnly?: boolean;
}) {
  const visibility = useLegacyInstrumentVisibility(session, readOnly);
  return <VisibilityEditor visibility={visibility} />;
}
